var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 145,
    viewBox: "0 0 71 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2688_18986)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 37.5254,
    cy: 110.5,
    r: 33.5,
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5448 28.3596L7.38482 29.7596C2.51482 30.8596 -0.65518 35.5596 0.14482 40.4896L6.08482 77.0696C6.90482 82.0996 11.5548 85.5696 16.6048 84.9296L29.0048 83.3496C34.9148 82.5996 38.6648 76.6296 36.7748 70.9796L24.5948 34.5796C23.0548 29.9696 18.2748 27.2896 13.5448 28.3596Z",
    fill: "#4A4A76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1947 105.449C22.1947 99.1195 17.0647 93.9795 10.7247 93.9795C9.91469 93.9795 9.11469 94.0695 8.35469 94.2295C5.62469 99.0795 4.05469 104.669 4.05469 110.629C4.05469 112.099 4.16469 113.549 4.34469 114.969C6.16469 116.189 8.36469 116.909 10.7247 116.909C17.0547 116.909 22.1947 111.779 22.1947 105.449Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5242 127.29C64.6842 125.34 62.0842 124.12 59.1842 124.12C53.6042 124.12 49.0742 128.65 49.0742 134.23C49.0742 136.82 50.0542 139.17 51.6542 140.96C57.9142 138.03 63.1042 133.24 66.5242 127.29Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4101 133.797C37.5057 132.83 40.0419 128.726 39.0748 124.63C38.1077 120.535 34.0036 117.999 29.908 118.966C25.8123 119.933 23.2762 124.037 24.2433 128.133C25.2104 132.228 29.3145 134.764 33.4101 133.797Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.77 112.19C56.08 112.19 52.27 108.38 52.27 103.69V86.5596L40.52 82.5996C34.81 80.6596 31 75.3297 31 69.3297V39.8896C31 35.1996 34.81 31.3896 39.5 31.3896C44.19 31.3896 48 35.1996 48 39.8896V67.1796L61.38 71.6796C66.1 73.2696 69.27 77.6797 69.27 82.6597V103.69C69.27 108.39 65.47 112.19 60.77 112.19Z",
    fill: "#383838"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M60.77 109.36C56.08 109.36 52.27 105.55 52.27 100.86V83.7198L40.52 79.7698C34.81 77.8298 23 64 23 58L31 37.0498C31 32.3598 34.81 28.5498 39.5 28.5498C44.19 28.5498 48 32.3598 48 37.0498V64.3398L61.38 68.8398C66.1 70.4298 69.27 74.8398 69.27 79.8198V100.85C69.27 105.55 65.47 109.36 60.77 109.36Z",
    fill: "#58588D"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.4458 116.779C37.7558 116.779 33.9458 112.969 33.9458 108.279V90.1895L22.1658 87.1795C16.4858 85.2495 12.6758 79.9195 12.6758 73.9195V44.4795C12.6758 39.7895 16.4858 35.9795 21.1758 35.9795C25.8658 35.9795 29.6758 39.7895 29.6758 44.4795V71.5795L50.9458 76.9595V108.289C50.9458 112.969 47.1458 116.779 42.4458 116.779Z",
    fill: "#383838"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M42.4458 113.95C37.7558 113.95 33.9458 110.14 33.9458 105.45V87.3496L22.1658 84.3396C16.4858 82.4096 12.6758 77.0797 12.6758 71.0797V41.6396C12.6758 36.9496 16.4858 33.1396 21.1758 33.1396C25.8658 33.1396 29.6758 36.9496 29.6758 41.6396V68.7396L50.9458 74.1197V105.45C50.9458 110.14 47.1458 113.95 42.4458 113.95Z",
    fill: "#58588D"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2688_18986)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.3958 79.76C42.0558 79.76 40.7058 79.42 39.4558 78.72L23.4258 69.63C23.3458 69.59 23.2758 69.54 23.1958 69.5C17.0158 65.72 13.1758 58.86 13.1758 51.62V28.96C13.1758 24.54 16.7558 20.96 21.1758 20.96C25.5958 20.96 29.1758 24.54 29.1758 28.96V51.61C29.1758 53.29 30.0458 54.89 31.4658 55.79L47.3458 64.8C51.1858 66.98 52.5358 71.86 50.3558 75.71C48.8858 78.31 46.1758 79.76 43.3958 79.76Z",
    fill: "#8A8AB6"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2688_18986)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.2945 74.2803C58.2745 74.2803 58.2545 74.2803 58.2345 74.2803C54.3645 74.2503 51.2645 71.0804 51.2945 67.2204L51.4045 55.2304C51.3445 54.6604 50.9745 54.2004 50.7445 53.9704C47.0845 50.2204 45.0645 45.2604 45.0645 40.0204V17.3604C45.0645 13.4904 48.1945 10.3604 52.0645 10.3604C55.9345 10.3604 59.0645 13.4904 59.0645 17.3604V40.0103C59.0645 41.5803 59.6645 43.0604 60.7645 44.1804C63.6145 47.1004 65.2644 50.8804 65.4044 54.8204C65.4044 54.9204 65.4044 55.0304 65.4044 55.1304L65.2944 67.3403C65.2544 71.1903 62.1345 74.2803 58.2945 74.2803Z",
    fill: "#8A8AB6"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M39.0658 54.78C54.1929 54.78 66.4558 42.5171 66.4558 27.39C66.4558 12.2629 54.1929 0 39.0658 0C23.9387 0 11.6758 12.2629 11.6758 27.39C11.6758 42.5171 23.9387 54.78 39.0658 54.78Z",
    fill: "#C3C3D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6755 35.7298C44.8555 35.7298 33.4855 29.5498 26.3755 20.0098C24.9255 22.2798 24.1055 24.8198 24.1055 27.4998C24.1055 37.1298 34.5955 44.9398 47.5455 44.9398C53.5155 44.9398 58.9555 43.2698 63.0955 40.5298C64.0555 38.7798 64.8155 36.9198 65.3855 34.9698C62.8855 35.4698 60.3155 35.7298 57.6755 35.7298Z",
    fill: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.375 20.0199C33.495 29.5599 44.865 35.7399 57.675 35.7399C60.315 35.7399 62.885 35.4699 65.375 34.9799C66.065 32.5699 66.445 30.0299 66.445 27.3999C66.445 22.7699 65.295 18.4199 63.265 14.5999C59.105 11.7999 53.585 10.0899 47.535 10.0899C38.195 10.0699 30.135 14.1299 26.375 20.0199Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8153 29.1504C57.8953 29.1504 57.0653 28.5104 56.8653 27.5704C55.8453 22.8104 51.5653 19.3604 46.6953 19.3604C45.5953 19.3604 44.6953 18.4604 44.6953 17.3604C44.6953 16.2604 45.5953 15.3604 46.6953 15.3604C53.4453 15.3604 59.3653 20.1404 60.7753 26.7304C61.0053 27.8104 60.3153 28.8704 59.2353 29.1104C59.0953 29.1304 58.9553 29.1504 58.8153 29.1504Z",
    fill: "#DFDFEB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2688_18986",
    x: 13.1758,
    y: 20.96,
    width: 38.2227,
    height: 61.7998,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2688_18986"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2688_18986",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2688_18986",
    x: 45.0645,
    y: 10.3604,
    width: 20.3398,
    height: 66.9199,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2688_18986"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2688_18986",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2688_18986"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70.95,
    height: 144.09,
    fill: "white",
    transform: "translate(0.0253906)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.9e85d7b99c5eb9d68272fc8b963cb487.svg";
export { ForwardRef as ReactComponent };